module.exports = __webpack_public_path__ + "img/Content2.9ce3e5a4.png";